import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="Page introuvable" description="Cette page n'existe pas." path="/404" />
      <section className="bg-brand-page min-h-[80vh] flex items-center justify-center px-5 py-20" data-testid="not-found">
        <div className="text-center max-w-2xl">
          <div className="font-heading font-black tracking-tighter text-[10rem] md:text-[14rem] leading-none text-brand-blue/20">404</div>
          <h1 className="font-heading font-black tracking-tighter text-4xl md:text-5xl text-brand-ink mt-4">Page introuvable</h1>
          <p className="mt-4 text-slate-600">Cette page n'existe pas ou a été déplacée. Retournons à l'accueil.</p>
          <Link to="/" className="mt-8 btn-cta inline-flex" data-testid="not-found-cta">Retour à l'accueil</Link>
        </div>
      </section>
    </>
  );
}
